export const calculateResult = function (status, odd, stake) {
    return status == "FAIL"
        ? -stake
        : status == "HALF_LOSS"
            ? -stake / 2
            : status == "VOID"
                ? 0
                : status == "HALF_WIN"
                    ? (stake * (odd - 1)) / 2
                    : stake * (odd - 1);
}
export const getStatus = function (status) {
    switch (status) {
        case 0:
        case "0":
        case "PENDING":
            return "PENDING";
        case 1:
        case "1":
        case "SUCCESS":
            return "SUCCESS";
        case 2:
        case "2":
        case "FAIL":
            return "FAIL";
        case 3:
        case "3":
        case "VOID":
            return "VOID";

        case 4:
        case "4":
        case "HALFWIN":
            return "HALF_WIN";
        case 5:
        case "5":
        case "HALFLOSS":
            return "HALF_LOSS";
    }
}

export const menuIcons = {
	home: {
		default: '/img/menu/home.svg',
		outline: '/img/menu/home.outline.svg',
		active: '/img/menu/home.selected.svg',
	},
	settings: {
		default: '/img/menu/settings.svg',
        outline: '/img/menu/settings.outline.svg',
		active: '/img/menu/settings.selected.svg',
	},
	support: {
		default: '/img/menu/help.svg',
        outline: '/img/menu/help.outline.svg',
		active: '/img/menu/help.selected.svg',
	},
	logout: {
		default: '/img/menu/logout.svg',
        outline: '/img/menu/logout.outline.svg',
		active: '/img/menu/logout.selected.svg',
	},
	openclaw: {
		default: '/img/menu/openclaw.svg',
		outline: '/img/menu/openclaw.outline.svg',
		active: '/img/menu/openclaw.selected.svg',
	},
	acca: {
		default: '/img/menu/acca.svg',
		outline: '/img/menu/acca.outline.svg',
		active: '/img/menu/acca.selected.svg',
	},
	profile: {
		default: '/img/menu/profile.svg',
		outline: '/img/menu/profile.svg',
		active: '/img/menu/profile.svg',
	}
}